<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">

  <path d="m10.36133,6.32812L5.0293.99609c-.37109-.36914-.97266-.36914-1.34375,0-.37012.37109-.37012.97266,0,1.34375l4.66016,4.66016-4.66016,4.66016c-.37012.37109-.37012.97266,0,1.34375.18555.18457.42871.27734.67188.27734s.48633-.09277.67188-.27734l5.33203-5.33203c.37012-.37109.37012-.97266,0-1.34375Z" fill="var(--iconPrimary, #222)"/>
  
</svg>